import { CUSTOM_ERROR_INFO } from '@/constants/general'

export const SPLUNK_RUM_FIELDS = {
  WORKFLOW: 'workflow.name',
  PRINTER_COUNTRY: 'printer.country',
  DHP_PATH: 'dhp.path',
  MODEL_NAME: 'model.name',
  FLOW_TYPE: 'flow.type',
  RESPONSE_STATUS: 'response.status',
  RESPONSE_BODY: 'response.body',
} as const

const WORKFLOW_VALUE_PROP = {
  VALUE_PROP_CREATE_ACCOUNT: 'ValuePropCreateAccount',
  VALUE_PROP_SIGN_IN: 'ValuePropSignIn',
  VALUE_PROP_CONTINUE: 'ValuePropContinue',
  VALUE_PROP_SKIP: 'ValuePropSkip',
}

const WORKFLOW_FW_UPDATE = {
  FW_UPDATE_AUTO: 'AutoFwUpdateChoice',
  FW_UPDATE_NOTIFY: 'NotifyFwUpdateChoice',
}

const WORKFLOW_HW_STATUS_CHECK = {
  HW_STATUS_CHECK_PRINTER_RESOURCES: 'HwStatusCheckPrinterResources',
}

export const SPLUNK_RUM_WORKFLOWS = {
  DHP_ERRORS: 'DhpError',
  SHORTCUT_CREATION_ERROR: 'ShortcutCreationError',
  SHORTCUTS_SESSION_CREATION_ERROR: 'ShortcutsSessionCreationError',
  NAME_AND_LOC_ACTIVATION_ERROR: 'NameAndLocActivationError',
  UNABLE_FETCH_CMS: CUSTOM_ERROR_INFO.UNABLE_FETCH_CMS.errorCode,
  UNABLE_PAGE_RENDER: CUSTOM_ERROR_INFO.UNABLE_PAGE_RENDER.errorCode,
  PROGRAM_LOCALE_COUNTRIES_ERROR: 'ProgramLocaleCountriesError',
  ...WORKFLOW_VALUE_PROP,
  ...WORKFLOW_FW_UPDATE,
  ...WORKFLOW_HW_STATUS_CHECK,
} as const

export type SplunkRumFields = typeof SPLUNK_RUM_FIELDS

export type SplunkRumWorkflows = typeof SPLUNK_RUM_WORKFLOWS
